<ion-content>
  <mable-heading heading="h2"
    >{{ terms?.organisationName }} added/updated their terms and conditions for your agreement with
    {{ terms?.consumerFirstName }}</mable-heading
  >
  <p class="ion-margin-horizontal">
    <strong
      >Review and accept the terms and conditions before you offer an agreement to
      {{ terms?.consumerFirstName }}.</strong
    >
  </p>
  <app-view-formatted-editor-text
    class="terms"
    [content]="terms?.contentOfTerms"
  ></app-view-formatted-editor-text>
  <div class="ion-margin-horizontal">
    <p *ngIf="terms?.email || terms?.phoneNumber">
      In the event of an incident during a support session, you can contact your client’s provider organisation at:
    </p>
    <p *ngIf="terms?.email"><strong>Email: </strong>{{ terms?.email }}</p>
    <p *ngIf="terms?.phoneNumber"><strong>Phone number: </strong>{{ terms?.phoneNumber }}</p>
    <p *ngIf="terms?.email || terms?.phoneNumber">You can always find this information on the ‘My clients’ page.</p>
    <p>
      By accepting, you agree to {{ terms?.organisationName }}'s terms and conditions when you enter into an agreement
      with their clients.
    </p>
    <ng-container *ngIf="terms?.organisationEmail || terms?.organisationPhone">
      <p>
        You MUST review and accept {{ terms?.organisationName }}'s terms and conditions before you can enter into an
        agreement with {{ terms?.consumerFirstName }}. If you have any questions about these terms and conditions, you
        can contact your client's provider organisation at:
      </p>
      <p *ngIf="terms?.organisationEmail">
        <span class="bold">Email: </span><span>{{ terms?.organisationEmail }}</span>
      </p>
      <p *ngIf="terms?.organisationPhone">
        <span class="bold">Phone number: </span><span>{{ terms?.organisationPhone }}</span>
      </p>
    </ng-container>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col>
          <mable-button
            expand="block"
            category="outline"
            (onClick)="cancel()"
            >{{ action === 'add' || isAgreementRequested ? 'Go back' : 'Not now' }}
          </mable-button>
        </ion-col>
        <ion-col>
          <mable-button
            expand="block"
            (onClick)="acceptTermsAndConditions()"
            >Accept</mable-button
          >
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
